<script>
  import {mapState, mapActions, mapGetters} from 'vuex'
  import draggable from 'vuedraggable'

  export default {
    props: {
      name: String,
      title: String,
      showType: {
        type: Boolean,
        default: true,
      },
      showCol: {
        type: Boolean,
        default: true,
      },
      showHeight: {
        type: Boolean,
        default: true,
      },

    },
    data() {
      return {}
    },
    methods: {
      ...mapActions('settings', {
        get: 'get',
        cancel: 'cancel',
        reset: 'reset',
        close: 'close',
        save: 'save',
        change_setting: 'change_setting',
        change_data: 'change_data',
        change_position: 'change_position',
        change_opened: 'change_opened',
      }),
    },
    computed: {
      data() {
        if (!this.$store.state.settings[this.name]) return {};
        return this.$store.state.settings[this.name];
      },
      filters() {
        if (!this.$store.state.settings[this.name]) return {};
        return this.$store.state.settings[this.name].filters;
      },
      opened() {
        if (!this.$store.state.settings[this.name]) return null;
        return this.$store.state.settings[this.name].opened;
      },
      checkAllVisible:{
        get(){
          return !this.data.columns.find(i=>!i.visible)&&!!this.data.columns.length;
        },
        set(value){
          this.data.columns.forEach(i=>i.visible=value);
        }
      },
      isIndeterminateVisible(){
        return !!this.data.columns.find(i=>i.visible)&&!this.checkAllVisible
      },
    },
    watch: {},
    components: {draggable},
    mounted() {
      this.get(this.name);
    },
    destroyed() {

    },
  }
</script>
<template>
  <el-dialog :visible="data.visible" custom-class="mag-setting" :title="title" class="dialog" @close="cancel(name)">
    <el-tabs>
      <el-tab-pane label="Основные">
        <el-form label-width="400px">
          <el-form-item label="Тип отображения" v-if="showType">
            <el-select
              :value="data.type"
              @change="change_data({field:'type', name, value: $event})">
              <el-option value="Tiled" label="Плитками"></el-option>
              <el-option value="Custom" label="Табличный (расширенный режим)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Количество элементов на странице" v-if="showCol">
            <el-input-number v-model="data.col" :step="5" :min="10" :max="50"></el-input-number>
          </el-form-item>
          <el-form-item label="Высота таблицы" v-if="showHeight">
            <el-input-number
              :value="data.height"
              @change="change_data({field:'height', name, value: $event})"
              :step="50"
              :min="100"
              :max="2000">
            </el-input-number>
          </el-form-item>
          <el-form-item label="Фиксировать высоту таблицы" v-if="showHeight">
            <el-switch
              :value="data.heightFixed"
              @input="change_data({field:'heightFixed', name, value: $event})"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
          <el-form-item label="Обновлять данные при возрате на страницу">
            <el-switch
              :value="data.search"
              @input="change_data({field:'search', name, value: $event})"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
          <el-form-item label="Поиск по умолчанию">
            <el-select :value="data.defaultFilter"
                       @change="change_data({field:'defaultFilter', name, value: $event})">
              <el-option v-for="filter in filters" :key="filter.id" :value="filter.id" :label="filter.name"></el-option>
            </el-select>
          </el-form-item>
          <slot name="main-form" :data="data" :change_data="change_data"></slot>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Настройка таблицы">
        <el-row type="flex" :gutter="20" style="margin-bottom:20px;">
          <el-col :span="2">
            <el-checkbox
              :indeterminate="isIndeterminateVisible"
              v-model="checkAllVisible"
              :title="checkAllVisible?'Скрыть все колонки':'Показать все колонки'"
            />
          </el-col>
          <el-col :span="10">Название</el-col>
          <el-col :span="8">Ширина</el-col>
          <el-col :span="4" style="text-align: center;">Фиксировать</el-col>
        </el-row>
        <draggable :list="data.columns" @end="change_position({value: data.columns, name})">
          <transition-group>
            <el-row v-for="item in data.columns" :key="item.index" type="flex" :gutter="20" style="margin-bottom:10px;">
              <el-col :span="1">
                <el-checkbox v-model="item.visible"></el-checkbox>
              </el-col>
              <el-col :span="11">
                {{item.label}}
              </el-col>
              <el-col :span="8">
                <el-input-number v-model="item.width" type="number" :step="10" :min="30" :max="1000"></el-input-number>
              </el-col>
              <el-col :span="4" style="text-align: center;">
                <el-checkbox v-model="item.fixed"></el-checkbox>
              </el-col>
            </el-row>
          </transition-group>
        </draggable>
      </el-tab-pane>
      <el-tab-pane label="Настройка фильтров">
        <slot name="filters"></slot>
      </el-tab-pane>
      <el-tab-pane label="Настройка ссылок" v-if="opened&&opened.list&&opened.list.length">
        <el-row type="flex" :gutter="20" v-for="item in opened.list" :key="item.field">
          <template v-if="item.type==='switch'">
            <el-col :span="2">
              <el-switch
                :value="opened[item.field]"
                @input="change_opened({field:item.field, name, value: $event})"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </el-col>
            <el-col :span="22">
              <span style="cursor: pointer" @click="change_opened({field: item.field, name, value: !opened[item.field]})">{{item.label}}</span>
            </el-col>
          </template>
          <template v-if="item.type==='label'">
            <el-col :span="24">{{item.label}} (открывать в новом окне):</el-col>
          </template>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <div class="dialog-footer">
      <el-button @click="cancel(name)">Отмена</el-button>
      <el-button @click="reset(name)">Сбросить настройки</el-button>
      <el-button type="primary" @click="save(name)">Сохранить</el-button>
    </div>
  </el-dialog>
</template>
<style lang="scss">
  .mag-setting {
    margin-top: 50px !important;

    .el-tabs__new-tab {
      margin: 10px;
      background: #fff;
    }
    .dialog-footer{
      background: #ffffff;
      position: sticky;
      bottom: 0;
      z-index: 10;
    }
  }
</style>
